<script>
    export let reset;
    export let isFiltered;
</script>

<button class="reset appButton" on:click={reset} disabled={!isFiltered}
    >Reset All</button
>
